import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PageLayoutSettingsService {
  readonly isLoginPage = signal(false);
}
